import React from "react";
import { createRoot } from "react-dom/client";
import GELDSTracker from "./GELDSTracker";
import "./style.css";

const root = createRoot(document.getElementById("root")!);
root.render(<GELDSTracker />);
